<span>{{ date() | date: 'dd/MM/yyyy' }}</span>
